import {combineReducers} from 'redux';
import OrderDetail from './OrderDetail/reducer';
import PaymentOrder from './PaymentOrder/reducer';

export default combineReducers({
    orderDetail: OrderDetail,
    paymentOrder: PaymentOrder
});
